import { useEffect } from "react";
import { gsap } from "gsap-trial";
import "./intro.scss";
import { useState } from "react";

const IntroAnimation = () => {
    

    useEffect(() => {
        
        const timeline = gsap.timeline({
            onComplete: () => {
                window.location.href = "/home";
            },
        });

    
            if (window.innerWidth > 768) {
                timeline
                    .fromTo(
                        ".para-intro-one",
                        {
                            clipPath:
                                "polygon(100% 0%, 100% 0%, 100% 100%, 100% 100%)",
                        },
                        {
                            clipPath: "polygon(0% 0%, 100% 0%, 100% 100%, 0% 100%)",
                            duration: 0.4,
                            ease: "power2.out",
                        },
                        "<0.2"
                    )
                    .fromTo(
                        ".para-intro-two",
                        { clipPath: "polygon(0% 0%, 0% 0%, 0% 100%, 0% 100%)" }, // Initially hidden
                        {
                            clipPath: "polygon(0% 0%, 100% 0%, 100% 100%, 0% 100%)",
                            duration: 0.4,
                            ease: "power2.out",
                        },
                        "<0.2"
                    )
                    .fromTo(
                        ".para-intro-three",
                        {
                            clipPath:
                                "polygon(100% 0%, 100% 0%, 100% 100%, 100% 100%)",
                        }, // Initially hidden
                        {
                            clipPath: "polygon(0% 0%, 100% 0%, 100% 100%, 0% 100%)",
                            duration: 0.4,
                            ease: "power2.out",
                        }
                    )
                    .fromTo(
                        ".space",
                        { opacity: 0, x: "-50px" },
                        { opacity: 1, x: "0px", duration: 0.5 }
                    )
                    .fromTo(
                        ".wrapper",
                        { x: "0" },
                        { x: "-100px", duration: 0.5 },
                        "<1"
                    )
                    .fromTo(
                        ".copy-one",
                        { opacity: 0, y: "0" },
                        { opacity: 1, y: "", duration: 0.5 },
                        "<0.25"
                    )
                    .fromTo(
                        ".copy-two",
                        { opacity: 0, y: "0" },
                        { opacity: 1, y: "", duration: 0.5 },
                        "<1"
                    )
                    .to(
                        ".copy-one",
                        {
                            opacity: 1,
                            y: "-0.5em",
                            duration: 0.5,
                        },
                        "<"
                    )
                    .to(
                        ".copy-two",
                        {
                            opacity: 1,
                            y: "-0.5em",
                            duration: 0.5,
                        },
                        "<"
                    )
                    .to(".wrapper", { x: "0px" }, "<1.5")
                    .to(
                        ".copy-one",
                        {
                            opacity: 0,
                            duration: 0.25,
                        },
                        "<"
                    )
                    .to(
                        ".copy-two",
                        {
                            opacity: 0,
                            duration: 0.25,
                        },
                        "<"
                    )
                    .fromTo(
                        ".industrial",
                        { opacity: 0, y: "50px" },
                        { opacity: 1, y: "0px", duration: 0.25, display: "flex" },
                        "<"
                    )
                    .to("copy-intro", {
                        display: "none",
                    })
                    .to("home-animation", {
                        duration: 1.5,
                    });
            }
            else{
                timeline
                .fromTo(
                    ".para-intro-one",
                    {
                        clipPath:
                            "polygon(100% 0%, 100% 0%, 100% 100%, 100% 100%)",
                    }, // Initially hidden
                    {
                        clipPath: "polygon(0% 0%, 100% 0%, 100% 100%, 0% 100%)",
                        duration: 0.4,
                        ease: "power2.out",
                    },
                    "<0.2"
                )
                .fromTo(
                    ".para-intro-two",
                    { clipPath: "polygon(0% 0%, 0% 0%, 0% 100%, 0% 100%)" }, // Initially hidden
                    {
                        clipPath: "polygon(0% 0%, 100% 0%, 100% 100%, 0% 100%)",
                        duration: 0.4,
                        ease: "power2.out",
                    },
                    "<0.2"
                )
                .fromTo(
                    ".para-intro-three",
                    {
                        clipPath:
                            "polygon(100% 0%, 100% 0%, 100% 100%, 100% 100%)",
                    }, // Initially hidden
                    {
                        clipPath: "polygon(0% 0%, 100% 0%, 100% 100%, 0% 100%)",
                        duration: 0.4,
                        ease: "power2.out",
                    }
                )
                .fromTo(
                    ".space",
                    { opacity: 0, x: "-50px" },
                    { opacity: 1, x: "0px", duration: 0.5 }
                )
                .fromTo(
                    ".industrial",
                    { opacity: 0, x: "50px" },
                    { opacity: 1, x: "0px", duration: 0.5, display: "flex" },
                    "<"
                )
            }
        
    }, []);

    return (
        <div className="home-animation">
            <div className="wrapper">
                <div className="space">
                    <h1 className="volt">Space</h1>
                </div>
                <div className="logo">
                    <svg
                        id="Layer_2"
                        data-name="Layer 2"
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 260.91 210"
                    >
                        <defs>
                            <style>{`.cls-1 {fill: #d4e16a;}`}</style>
                        </defs>
                        <g id="Layer_1-2" data-name="Layer 1">
                            <polygon
                                className="cls-1 para-intro-three"
                                points="58.33 210 100.76 148.25 213.18 148.25 170.76 210 58.33 210"
                            />
                            <polygon
                                className="cls-1 para-intro-two"
                                points="0 135.88 42.42 74.12 260.91 74.12 218.48 135.88 0 135.88"
                            />
                            <polygon
                                className="cls-1 para-intro-one"
                                points="46.88 61.75 89.3 0 201.73 0 159.3 61.75 46.88 61.75"
                            />
                        </g>
                    </svg>
                </div>
                <div className="industrial">
                    <h1 className="volt">Industrial</h1>
                </div>
            </div>
            <div className="copy-intro">
                <h1 className="copy-one">that works</h1>
                <h1 className="copy-two">for your business</h1>
            </div>
        </div>
    );
};

export default IntroAnimation;
